import { Component } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { PackageService } from '../../../services/package.service';
import { UtilService } from '../../../services/util.service';

@Component({
  selector: 'app-packages-page',
  templateUrl: './packages-page.component.html',
  styleUrl: './packages-page.component.scss'
})
export class PackagesPageComponent {

  public neighborhoodId?: string;
  
  constructor(
    public authService: AuthService,
    private activatedRoute: ActivatedRoute,
    public packageService: PackageService,
    public utilService: UtilService
  ) {
    this.activatedRoute.params.subscribe(
      async params => {
        this.neighborhoodId = params['neighborhoodId'];
        await this.packageService.getAll(
          this.neighborhoodId!
        );
      }
    );
  }

  getTitle(key: string): string {
    let title = '';

    switch (key) {
      case 'pending':
        title = 'Pendientes';
        break;
      case 'historical':
        title = 'Entregados';
        break;
      default:
        title = key;
        break;
    }

    return title;
  }

}
